var _defs, _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 402 403",
    width: 402,
    height: 403,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "P",
    gradientUnits: "userSpaceOnUse"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g1",
    x1: 317.8,
    y1: 146.5,
    x2: 234.4,
    y2: 258.2,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#70bd45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1b8972"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g2",
    x1: 267.5,
    y1: 105.2,
    x2: 182.9,
    y2: 218.4,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#70bd45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1b8972"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g3",
    x1: 159,
    y1: 32.9,
    x2: 75.3,
    y2: 145,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#70bd45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1b8972"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g4",
    x1: 206,
    y1: 60.6,
    x2: 120.4,
    y2: 175.2,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#70bd45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1b8972"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g5",
    x1: 369.2,
    y1: 190.1,
    x2: 284.6,
    y2: 303.4,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#70bd45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1b8972"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g6",
    x1: 402,
    y1: 212.5,
    x2: 316,
    y2: 327.6,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#70bd45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1b8972"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g7",
    x1: 415.8,
    y1: 218.8,
    x2: 330.9,
    y2: 332.5,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#70bd45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1b8972"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g8",
    x1: 409.1,
    y1: 201,
    x2: 322.6,
    y2: 316.7,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#70bd45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1b8972"
  })))), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".a{fill:url(#g1)}.b{fill:url(#g2)}.c{fill:url(#g3)}.d{fill:url(#g4)}.e{fill:url(#g5)}.f{fill:url(#g6)}.g{fill:url(#g7)}.h{fill:url(#g8)}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m193.4 191.9c19.7-1.5 38.3-3 53.9-5.4 8.6-1.3 18.7-3.3 28.3-5.7 1-0.2 1.8-0.9 2.3-1.7 0.5-0.9 0.6-2 0.3-2.9-0.9-3.1-2-6.2-3.1-9.3 51-9.9 81.3-26.5 90.2-49.4 8.2-21.2-5.7-39.8-6.3-40.6-1.1-1.5-3.2-1.9-4.7-1-1.6 1-2.3 2.9-1.6 4.6 4 9.6 3.8 18-0.6 25.8-11 19.8-48.2 34.8-110.4 44.8-12.4 2-28.6 3.4-47.3 5-63.4 5.5-150.3 13-179 53-9.5 13.3-12 29.3-7.5 47.5 0.3 1.5 1.6 2.7 3.5 2.8 1.5 0 2.8-0.9 3.4-2.2 23.2-53.2 109.4-59.9 178.6-65.3z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m7.8 189.4c12.3-47.4 87-54.9 147-60.9 17.8-1.7 34.6-3.4 48.1-6 13-2.5 25.5-5.3 37.1-8.2 1.2-0.3 2.2-1.2 2.5-2.4 0.4-1.2 0.2-2.5-0.6-3.5q-2-2.5-4.2-5c47.7-11.7 73.7-27.1 77.2-45.8 3.5-18.3-15.7-31.6-16.5-32.2-1.6-1.1-3.7-0.8-4.9 0.7-1.2 1.5-1.1 3.6 0.2 4.9 0.1 0.1 7.7 7.6 4.6 17.5-3.9 12.4-24.1 29.9-98.3 43-16.1 2.8-33.4 4.4-51.8 6-70 6.3-142.4 12.7-147.6 90.8-0.1 1.9 1.2 3.5 3.1 3.8l0.6 0.1c1.6 0 3.1-1.1 3.5-2.8z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "m85.2 45.4c0.7 0 1.4-0.2 1.9-0.5 17.3-10.6 37.7-11.1 55.7-11.6 24.9-0.7 48.5-1.4 57.8-28 0.4-1.1 0.2-2.4-0.5-3.4-0.7-0.9-1.8-1.4-3.1-1.5-7.4 0.2-15 0.8-22.4 1.8-1.5 0.2-2.7 1.2-3.1 2.6-2.1 7.3-20.4 11.7-38.2 15.9-17.7 4.2-37.8 8.9-50.2 18.1-1.6 1.2-2 3.4-0.9 5 0.7 1 1.8 1.6 3 1.6z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "m26.2 113.8c1.1 0 2.2-0.5 2.9-1.4 25.2-33.4 76.2-37.5 125.4-41.5 10.7-0.9 20.7-1.7 30.7-2.8 1.5-0.2 2.8-1.4 3.1-2.9 0.3-1.6-0.4-3.1-1.7-3.9q-1.1-0.7-2.2-1.3c34.5-5.5 72-21.8 73.2-37.9 0.7-8.4-7.4-14.8-24-19-1.9-0.5-3.9 0.6-4.4 2.5-0.6 1.9 0.4 3.8 2.3 4.5 6.8 2.3 9.2 4.6 9.2 6.1 0.1 4.5-13.6 13.2-30.5 19.3-19.4 7.2-40.9 9.1-61.7 11-44.6 4.1-90.8 8.3-125.4 61.7-1.1 1.6-0.7 3.8 1 5 0.6 0.4 1.3 0.6 2.1 0.6z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "m283.7 252.3c1.6-0.3 2.9-1.7 3-3.4 0.2-3.7 0.4-7.4 0.4-11.1 49.4-8.8 82.4-26.2 98.2-51.7 14-22.6 8.4-42.7 8.4-42.9-0.6-1.8-2.4-2.9-4.2-2.5-1.9 0.3-3.1 2-3 3.9 5 62-128.1 77.7-143.3 79.3l-9.9 1.1c-62.4 6.4-147.8 15.3-185.4 44.1-11.6 8.8-17.4 17-18.3 25.8-1.4 12.3 7.1 23.4 18.4 36.6 0.7 0.8 1.7 1.3 2.7 1.3 0.7 0 1.3-0.1 1.8-0.4 1.5-0.9 2.2-2.7 1.7-4.3-2.4-7.8-1.5-14.8 2.9-21.3 24.6-36.5 149.3-46.4 190.2-49.7 11.9-0.9 24.5-2.6 36.4-4.8z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "m398.7 217.1c-1.8-0.6-3.8 0.4-4.5 2.2-20.6 55.6-98.2 63.3-160.6 69.4-14.8 1.4-28.8 2.8-41 4.8-42.1 6.6-76.6 17.7-97.1 31.4-14.1 9.4-20.5 17.5-20.2 25.5 0.5 10.7 12.4 18.1 29.3 27.3 0.5 0.3 1.1 0.5 1.7 0.5 1.1 0 2.1-0.4 2.8-1.2 1.1-1.3 1.2-3.2 0.2-4.6-0.1-0.1-3.2-4.6-0.5-11 4.4-10.7 23.4-25.9 88.8-37.3 15.5-2.7 31.7-4.5 47.4-6.3h0.5c7.8-0.9 15.6-1.8 23.3-2.8 1.3-0.1 2.4-1 2.9-2.2 1.4-3.5 2.8-7 4-10.6 100.7-7.5 121.5-63.7 125.5-80.8 0.4-1.9-0.7-3.8-2.5-4.3z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "m375.8 294.1c-1.6-1-3.7-0.6-4.9 0.9-21.9 29.6-68.4 35.6-113.3 41.5-37.4 4.8-76 9.9-102.4 28.3-13.1 9.1-18.1 15.6-16.9 21.6 1.5 6.8 10.3 9.7 26 12.7q0.3 0 0.6 0c0.8 0 1.6-0.2 2.2-0.7 0.8-0.6 1.3-1.5 1.5-2.4 0-0.2 3.2-15.2 43.4-26.3 10.2-2.8 17.4-4.3 27.6-5.9 0.9-0.2 1.8-0.6 2.5-1.6 0.8-0.9 4-5.1 6.7-8.7 75.7-5.1 115.9-31.5 128.3-54.6 0.9-1.7 0.3-3.8-1.3-4.8z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "h",
    d: "m298.4 370.3c-0.6-0.2-54.8-15.1-93.7 25.9-1 1.1-1.3 2.8-0.6 4.1 0.6 1.3 1.8 2.1 3.5 2.1q0 0 0.1 0l21.7-1.9c1-0.1 2-0.5 2.6-1.3 0.1-0.2 17.9-20.9 59.7-18.8 0.6 0 1.3-0.1 1.9-0.4q2.8-1.5 5.6-3c1.3-0.7 2-2.2 1.8-3.6-0.1-1.5-1.2-2.7-2.6-3.1zm-0.4 1.4z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.036c5072f80009e6e811dc0974c1adda.svg";
export { ForwardRef as ReactComponent };